<template lang="pug">
  app-modal.modalNotificar(
    :titulo="titulo()"
    :width="width"
    @closeModal="$emit('closeModal')"
  )
    template(slot="body")
      app-modal-selecionar-modelo-notificacao(
        :tiposModelo="tiposModelo",
        titulo='Modelos de Notificação',
        :idProcesso="this.idProcesso"
        v-if="showModalNotificacao",
        :showModal="showModalNotificacao"
        @closeModal="fecharModalNotificacao",
        @setTextoNotificacao="setTextoNotificacao"
      )
      app-modal-visualiza-pdf(
        v-if="showModalVisualizaPdf",
        @closeModal="closeModalVisualizaPdf",
        :titulo="tituloModal",
        :tipo="tipoModal",
        :conteudo="conteudoModal",
        :isVTN="false",
        :isImagem="isImagem"
        :tituloDocumento="tituloDocumento"
      )
      div.mb(v-if="conversas.length > 0 && item.tipo === 'NOTIFICACAO_INTERESSADO' || item.assunto === 'Solicitação de cópia do processo'" v-for="item in conversas", :key="item.id")
        p
          b {{ item.tipo === 'NOTIFICACAO_INTERESSADO' ? 'Notificação' : 'Mensagem' }}: &nbsp{{ item.assunto }}
        el-collapse()
          el-collapse-item(
            v-for="msg in item.mensagemList",
            :key="msg.id",
            :name='msg.id',
          )
            template(slot="title")
              div.flex.title.full-width
                span {{ msg.nomeRemetente}}
                span {{ msg.dataEnviada }} &nbsp
            el-row.margin-top(v-if="msg.dataLimiteResposta")
              p
                b Data de vencimento:
                span &nbsp {{ msg.dataLimiteResposta }}
            el-row.margin-top
              p(v-html="msg.conteudo")

            el-row
                el-table(
                  :data='msg.anexoList',
                  stripe
                )
                  el-table-column.td-column-anexo(
                    prop='nome',
                  )
                  el-table-column.td-column-anexo(
                    align="center",
                    width="85"
                    )
                      template(slot-scope='scope')
                        app-action-button(
                          v-if="isEstadoAp"
                          :disabled="!isDocumentoParaVisualizacao(scope.row)"
                          :cor="!isDocumentoParaVisualizacao(scope.row) ? '#C0C4CC' : '#666666'",
                          :text="!isDocumentoParaVisualizacao(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar' ",
                          icone="eye",
                          fontSize="18",
                          @click="abrirDocumento(scope.row)"
                        )
                        app-action-button(
                          icone="download",
                          nome="file_download",
                          @click="download(scope.row)",
                          hoverColor="#009f61",
                          text="Baixar anexo"
                        )

      div(v-if="(!isNovaConversa || isIniciarConversa)")
        validation-observer(ref='validation' tag='form')
          el-row.mb
            el-col(:span="17")
              div(v-if="isNovaConversa || conversas.length === 0")
                el-row
                  app-label(
                    label="Assunto:",
                    :required="true"
                  )
                el-row
                  validation-provider(rules="required", v-slot="{ errors }")
                    el-input.input.width90(
                      :name="'assunto'"
                      v-model='assunto',
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}
              div(v-if="conversas && conversas.length > 0 && !isNovaConversa && !isSolicitacaoAcesso")
                el-row
                  app-label(
                    label="Status:",
                    :required="true"
                  )
                el-row()
                  div.radio()
                    el-radio-group(
                      v-model="fecharConversa"
                    )
                      el-radio(
                        :label='true',
                      ) Fechar conversa
                      el-radio(
                        :label='false',
                      ) Enviar Mensagem
            el-col(:span="7" v-if="!isSolicitacaoAcesso")
              div(v-if="conversas.length >= 0")
                el-row(
                    v-if="!fecharConversa"
                )
                  app-label(
                    label="Data de vencimento:",
                    :required="true"
                  )
                el-row(v-if="!fecharConversa || isNovaConversa")
                  validation-provider( :rules="{ required: !fecharConversa }", v-slot="{ errors }")
                    el-date-picker.input.date(
                      disabled
                      type="date",
                      placeholder="Prazo",
                      format="dd/MM/yyyy",
                      v-model="prazo",
                      :class="{'erro' : errors.length}",
                      :picker-options='options'
                    )
                    span.help.erro {{ errors[0] }}
          div.display-flex
            div.label-width
              app-label(
                label="Mensagem:",
                :required="true"
              )
            div
              el-button.btn(
                type="primary",
                @click="openModalNotificacao()",
              )
                span.center
                  i.fa.fa-file.icon
                  b &nbsp Modelo
          validation-provider(rules="required", v-slot="{ errors }")
            app-editor-texto.input(
              :value="mensagem",
              @onTextChange="onTextChange"
              :class="{'erro' : errors.length}"
              ref="editorTexto"
            )
            span.help.erro {{ errors[0] }}

          h4 Anexos mensagem
          app-anexo(
            :id="'upload-notificacao'"
            @removeFile="removeFile",
            @uploadFile="uploadFile",
            :exibirDownload="false",
            :files="anexos",
            scope="anexos",
            v-model="anexos",
          )
    template(slot="footer")
      .flex
        el-button.btn(
          type="default",
          size="small",
          @click="$emit('closeModal')"
        )
          span.center
            i.fa.fa-times
            b &nbsp Cancelar
        el-button.btn(
          type="success",
          size="small",
          @click="sendMessage()",
          v-if="(!isNovaConversa || isIniciarConversa)"
        )
          span.center
            i.fa.fa-share-square
            b &nbsp Enviar
        el-button.btn(
          type="success",
          size="small",
          @click="isIniciarConversa = true",
          v-if="isNovaConversa && !isIniciarConversa"
        )
          span.center
            i.fa.fa-share-square
            b &nbsp Iniciar nova Conversa
</template>

<script>
import AppAnexo from '@/components/AppAnexo'
import AppDisplay from '@/components/AppDisplay'
import AppDownloadArquivo from '@/components/AppDownloadArquivo'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppLabel from '@/components/AppLabel'
import AppModal from '@/components/AppModal'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'
import FileHelper from '@/utils/fileHelper'
import utils from '@/utils/utils'
import moment from 'moment'
import { mapActions } from 'vuex'
import AppActionButton from '../../../../components/AppActionButton'
import AppModalSelecionarModeloNotificacao from '../../components/AppModalSelecionarModeloNotificacao'
const {visualizarDocumentosPDF} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  components: {
    AppDisplay,
    AppLabel,
    AppModal,
    AppAnexo,
    AppEditorTexto,
    AppModalSelecionarModeloNotificacao,
    AppDownloadArquivo,
    FileHelper,
    AppActionButton,
    AppModalVisualizaPdf
  },

  mixins: [
    AppNotificacao
  ],
  props: {
    width: {
      type: Number,
      default: 850
    },
    isVisualizacao: {
      type: Boolean,
      default: false
    },
    idProcesso: {
      required: false
    },
    idDespacho: {
      required: true
    },
    setor: {
      type: String
    },
    isSubProcesso: {
      type: Boolean,
      default: false
    },
    isSolicitacao: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      anexos: [],
      prazo: null,
      assunto: '',
      mensagem: '',
      conversas: [],
      aba: false,
      isEstadoMa: process.env.ESTADO === 'ma',
      isEstadoBa: process.env.ESTADO === 'ba',
      isEstadoAp: process.env.ESTADO === 'ap',
      tituloModal: '',
      tipoModal: null,
      conteudoModal: null,
      showModalVisualizaPdf: false,
      isImagem: false,
      tituloDocumento: '',
      isNovaConversa: false,
      fecharConversa: false,
      isIniciarConversa: false,
      showModalNotificacao: false,
      isSolicitacaoAcesso: false,
      tiposModelo: [2], // Notificação
      usuario: null,
      options: {
        disabledDate (time) {
          return time.getTime() <= Date.now()
        },
        shortcuts: [
          {
            text: '10 dias',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() + (3600 * 1000 * 24 * 10))
              picker.$emit('pick', date)
            }
          }, {
            text: '15 dias',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() + (3600 * 1000 * 24 * 15))
              picker.$emit('pick', date)
            }
          }, {
            text: '20 dias',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() + (3600 * 1000 * 24 * 20))
              picker.$emit('pick', date)
            }
          }, {
            text: '30 dias',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() + (3600 * 1000 * 24 * 30))
              picker.$emit('pick', date)
            }
          }, {
            text: '60 dias',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() + (3600 * 1000 * 24 * 60))
              picker.$emit('pick', date)
            }
          }
        ]
      }
    }
  },

  async created () {
    this.usuario = await this.getUsuario()
    const { id } = this.usuario
    await this.getPrazoNotificacao()
    const { content } = await this.conversaByProcessoId({ idProcesso: this.idProcesso, idUsuario: id, tamanhoPagina: 100, isSolicitacaoAcesso: this.isSolicitacao })
    this.conversas = content

    if (this.conversas && this.conversas.length > 0) {
      this.isNovaConversa = this.conversas[this.conversas?.length - 1].status === 'ENCERRADA'
      this.isSolicitacaoAcesso = this.conversas[this.conversas?.length - 1].assunto === 'Solicitação de cópia do processo'
      this.$emit('updateHasConversa', this.isNovaConversa)
    }
  },

  methods: {
    ...mapActions({
      criarMensagem: 'conversa/criarMensagem',
      addMensagem: 'conversa/addMensagem',
      encerrarConversa: 'conversa/encerrarConversa',
      conversaByProcessoId: 'conversa/conversaByProcessoId',
      getUsuario: 'auth/getUsuario',
      downloadDocumentos: 'download/download',
      getPrazoNotificacaoByTipo: 'prazoNotificacao/getPrazoNotificacaoByTipo'
    }),

    async getPrazoNotificacao () {
      const today = new Date()
      const prazoNotificacao = await this.getPrazoNotificacaoByTipo('TODOS')
      // Pega a data atual e soma com o prazo de Notificação
      this.prazo = today.setDate(today.getDate() + prazoNotificacao)
    },

    titulo () {
      return this.conversas?.length === 0 ? 'Notificar Interessado' : 'Mensagens'
    },

    formataDataHora (data) {
      return moment(data).format('DD/MM/YYYY HH:mm')
    },

    formataData (data) {
      return moment(data).format('DD/MM/YYYY')
    },

    async uploadFile (file) {
      this.anexos.push({ key: file.response, nome: file.name })
    },

    abaAtiva () {
      this.aba = !this.aba
    },

    removeFile (file) {
      const teste = this.anexos.findIndex(obj => obj === file)
      this.anexos.splice(teste, 1)
    },
    onTextChange (value) {
      this.mensagem = value
    },

    async checkValidacao () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Por favor, preencha os campos obrigatórios.')
        return false
      }
      return true
    },

    async sendMessage () {
      if (!await this.checkValidacao() && !this.isSolicitacaoAcesso) {
        return
      }

      let mensagem = {
        mensagemList: [
          {
            anexoList: this.anexos,
            conteudo: this.mensagem,
            dataLimiteResposta: this.prazo
          }
        ],
        processo: {
          id: this.idProcesso
        }
      }

      if (this.isNovaConversa || this.conversas?.length === 0) {
        mensagem.tipo = 'NOTIFICACAO_INTERESSADO'
        mensagem.assunto = this.assunto
        if (this.isSubProcesso) {
          mensagem.subProcessoDespacho = (this.idDespacho === null || this.idDespacho === undefined) ? null : {id: this.idDespacho}
          mensagem.tipoNotificacao = 'NOTIFICACAO_INTERESSADO'
        } else {
          mensagem.despacho = (this.idDespacho === null || this.idDespacho === undefined) ? null : {id: this.idDespacho}
          mensagem.tipoNotificacao = 'NOTIFICACAO_INTERESSADO'
        }
        this.criarMensagem(mensagem).then(() => {
          this.feedBack('A notificação foi enviada com sucesso.')
          this.isGoBack()
        })
      }

      if (!this.isNovaConversa) {
        // eslint-disable-next-line
        this.conversas?.map((conversa, index) => {
          if ((conversa.status === 'ABERTA' && !this.fecharConversa) || this.isSolicitacaoAcesso) {
            if (index === this.conversas.length - 1 && this.isSolicitacao) {
              mensagem.id = conversa.id
              this.addMensagem(mensagem).then(() => {
                this.feedBack('A Mensagem foi enviada com sucesso.')
                this.isGoBack()
              })
            } else if (!this.isSolicitacao) {
              mensagem.id = conversa.id
              this.addMensagem(mensagem).then(() => {
                this.feedBack('A notificação foi enviada com sucesso.')
                this.isGoBack()
              })
            }
          } else if (conversa.status === 'ABERTA' && this.fecharConversa) {
            mensagem.id = conversa.id
            this.encerrarConversa(mensagem).then(() => {
              this.feedBack('Conversa fechada com sucesso')
            })
          }
        })
      }
    },

    feedBack (msg) {
      this.$emit('updateHasConversa', true)
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        msg
      )
      this.$emit('closeModal')
    },

    setTextoNotificacao (textoNotificacao) {
      this.$refs.editorTexto.text = textoNotificacao
      this.$refs.editorTexto.emitTextChange()
    },

    openModalNotificacao () {
      this.showModalNotificacao = true
    },

    fecharModalNotificacao () {
      this.showModalNotificacao = false
    },

    async download (anexo) {
      const arquivo = await this.downloadDocumentos(anexo)

      FileHelper.saveFile(arquivo, anexo.nome)
    },
    isGoBack () {
      if (this.isEstadoMa) {
        this.$router.back()
      }
    },
    abrirImagem (row) {
      let extensao = utils.getExtensionFile(row.nome)
      return visualizarDocumentosPDF.extensaoImagens.includes(extensao)
    },
    isDocumentoParaVisualizacao (row) {
      let extensao = utils.getExtensionFile(row.nome)
      return visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)
    },
    abrirDocumento (documento) {
      this.tipoModal = 'DOCUMENTO_MENSAGEM'
      this.tituloModal = 'Documento'
      this.conteudoModal = documento.id
      this.isImagem = this.abrirImagem(documento)
      this.showModalVisualizaPdf = true
      this.tituloDocumento = 'Documento'
    },
    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    }
  }
}

</script>

<style scoped lang="scss">
p.message {
  width: 80%;
  margin: 0 auto;
}

.flex {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}

.title {
  font-weight: 400;
  color: #909399 !important;
  font-size: 16px !important;
}

.width80 {
  width: 80%;
}

.mb {
  margin-top: 10px;
  margin-bottom: 18px;
}
.width90 {
  width: 97%;
}
.full-width {
  width: -webkit-fill-available;
}

.bold {
  font-weight: bold;
}

.cancelar-solicitacao i {
  margin-right: 30px;
  cursor: pointer;
  color: #339d67 !important;
}

.cancelar-solicitacao i:hover {
  color: #3bb281 !important;
}

.display-flex {
  width: 100%;
  display: flex;
}

.center {
  display: flex;
  align-items: center;
}

.label-width {
  width: 90%;
}

.btn {
  padding: 7px;
}

@media (max-width: 780px) {
  .modalNotificar {
    position: fixed !important;
    width: 395px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalNotificarInteressado.vue